import { Segment } from '@fixter/i18n';
import type { ILink } from '@/components/atoms/SimpleLink';

export function makeViewAllLink(collectionType: string, segment?: Segment): ILink | undefined {
  let name;
  let link;

  const frSegment = segment === Segment.Fixter_FR;

  switch (collectionType) {
    case 'product':
      name = frSegment ? 'Voir tous les services' : 'View all services';
      link = frSegment ? '/nos-services' : '/our-services';
      break;
    case 'area':
      name = frSegment ? 'Voir tous les emplacements' : 'View all locations';
      link = frSegment ? '/emplacements' : '/locations';
      break;
    case 'carMake':
      name = frSegment ? 'Voir toutes les marques de voitures' : 'View all car makes';
      link = frSegment ? '/voitures' : '/cars';
      break;
    default:
    // do nothing
  }

  return name && link
    ? {
        name,
        link,
        type: 1,
      }
    : undefined;
}
